/**
 * The product lines the floor actually makes.
 *
 * Its own file, with NO imports, deliberately. This list is needed by the
 * workbook parser, the Masterfile override and the subcon costing rollup —
 * all pure, all tested — and living in ProductionGridService.ts would drag the
 * SharePoint client and MSAL into every one of those test files. A constant
 * that cannot be unit-tested without an auth config is a constant in the wrong
 * place.
 *
 * NURSE UNIFORM and DOCTORS COAT were missing until 2026-08-25, and the
 * consequence was quiet rather than loud: the parser rewrites any category it
 * does not recognise to CLASSIC, so every nurse uniform and doctor's coat in
 * the workbook has been arriving labelled CLASSIC. Nothing errored and no
 * count went missing — the work was simply filed under the wrong line, which
 * is the hardest kind of wrong to notice from a total.
 *
 * ONE LIST, three consumers. They validated against three separate literals
 * before, which is how two of them can be right and one wrong.
 */
export const CATEGORIES = [
  "CLASSIC", "ELITE", "ALTA", "PRIMO", "ELITE PRO", "NURSE UNIFORM", "DOCTORS COAT",
] as const;

export type Category = (typeof CATEGORIES)[number];

/** Whether a workbook cell names a line we know. Callers upper-case first. */
export function isCategory(v: string): v is Category {
  return (CATEGORIES as readonly string[]).includes(v);
}
